
    import _Handlebars from 'handlebars/runtime';
    var Handlebars = _Handlebars.default;
    import "i18n!calendar.edit_event";
import "coffeescripts/handlebars_helpers.coffee";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = 'calendar/editEvent';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, self=this;

function program1(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n      <li><a href=\"#edit_appointment_group_form_holder\" class=\"edit_appointment_group_option\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("calendar.edit_event")
  },data:data},helper ? helper.call(depth0, "tabs.appointment_group", "Appointment Group", options) : helperMissing.call(depth0, "t", "tabs.appointment_group", "Appointment Group", options)))
    + "</a></li>\n    ";
  return buffer;
  }

  buffer += "<div class=\"content\" id=\"edit_event_tabs\">\n  <ul class=\"tab_list\">\n    <li><a href=\"#edit_calendar_event_form_holder\" class=\"edit_calendar_event_option\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("calendar.edit_event")
  },data:data},helper ? helper.call(depth0, "tabs.event", "Event", options) : helperMissing.call(depth0, "t", "tabs.event", "Event", options)))
    + "</a></li>\n    <li><a href=\"#edit_assignment_form_holder\" class=\"edit_assignment_option\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("calendar.edit_event")
  },data:data},helper ? helper.call(depth0, "tabs.assignment", "Assignment", options) : helperMissing.call(depth0, "t", "tabs.assignment", "Assignment", options)))
    + "</a></li>\n    <li><a href=\"#edit_planner_note_form_holder\" class=\"edit_planner_note_option\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("calendar.edit_event")
  },data:data},helper ? helper.call(depth0, "tabs.todo", "My To Do", options) : helperMissing.call(depth0, "t", "tabs.todo", "My To Do", options)))
    + "</a></li>\n    <li><a href=\"#edit_todo_item_form_holder\" class=\"edit_todo_item_option\">--</a></li>\n    ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.showAppointments), {hash:{},inverse:self.noop,fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  </ul>\n  <div id=\"edit_calendar_event_form_holder\" class=\"tab_holder clearfix\"></div>\n  <div id=\"edit_assignment_form_holder\" class=\"tab_holder clearfix\"></div>\n  <div id=\"edit_appointment_group_form_holder\" class=\"tab_holder clearfix\"></div>\n  <div id=\"edit_planner_note_form_holder\" class=\"tab_holder clearfix\"></div>\n  <div id=\"edit_todo_item_form_holder\" class=\"tab_holder clearfix\"></div>\n</div>\n";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  